<h2 mat-dialog-title>Opciones de Carga</h2>
<mat-dialog-content>
  <div class="container py-3">
    <div class="mb-4">
      <mat-card>
        <mat-card-content>
          <div class="d-flex align-items-center gap-2">
            <mat-icon class="text-primary">description</mat-icon>
            <div>
              <p class="mb-1"><strong>Archivo seleccionado:</strong> {{data.nombreArchivo}}</p>
              <p class="mb-0"><strong>Período detectado:</strong> {{data.periodo}}</p>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <mat-radio-group [(ngModel)]="opcionSeleccionada" class="d-flex flex-column gap-3">
      <mat-card [class.selected-option]="opcionSeleccionada === 'NUEVA'" (click)="opcionSeleccionada = 'NUEVA'">
        <mat-card-content>
          <mat-radio-button value="NUEVA" class="w-100">
            <div class="option-content">
              <div class="d-flex align-items-center gap-2">
                <mat-icon class="text-success">add_circle</mat-icon>
                <h3 class="mb-0">Carga Normal</h3>
              </div>
              <p class="mt-2 mb-1">Agregar nuevos registros al período</p>
              <small class="text-muted">Use esta opción si está agregando nuevas bonificaciones al período actual.</small>
            </div>
          </mat-radio-button>
        </mat-card-content>
      </mat-card>

      <mat-card [class.selected-option]="opcionSeleccionada === 'REEMPLAZAR'" (click)="opcionSeleccionada = 'REEMPLAZAR'">
        <mat-card-content>
          <mat-radio-button value="REEMPLAZAR" class="w-100">
            <div class="option-content">
              <div class="d-flex align-items-center gap-2">
                <mat-icon class="text-warning">warning</mat-icon>
                <h3 class="mb-0">Reemplazar Datos del Período</h3>
              </div>
              <p class="mt-2 mb-1 text-warning">Esta acción eliminará todos los registros existentes del período.</p>
              <small class="text-muted">Use esta opción si desea reemplazar los datos existentes.</small>
            </div>
          </mat-radio-button>
        </mat-card-content>
      </mat-card>
    </mat-radio-group>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancelar()">Cancelar</button>
  <button mat-raised-button 
  color="primary"  
  [disabled]="!opcionSeleccionada"
  (click)="confirmar()">Continuar</button>
</mat-dialog-actions>
